var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 76,
    viewBox: "0 0 116 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_178_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 4V52.5714H107.091V47.7143H102.182V42.8571H97.273V38H87.4548V42.8571H82.5457V47.7143H77.6366V52.5714H72.7275V57.4286H67.8184V62.2857H62.9093V67.1429H58.0002V72H48.1821V67.1429H43.273V62.2857H38.3639V57.4286H33.4548V52.5714H23.6366V57.4286H18.7275V62.2857H4.00024V47.7143H8.90934V42.8571H13.8184V38H18.7275V33.1429H23.6366V28.2857H33.4548V33.1429H38.3639V38H43.273V42.8571H48.1821V47.7143H58.0002V42.8571H62.9093V38H67.8184V33.1429H72.7275V28.2857H77.6366V18.5714H72.7275V13.7143H67.8184V8.85714H62.9093V4H112Z",
    fill: "#58CD4C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 4V2H112H62.9093H60.9093V4V8.85714V10.8571H62.9093H65.8184V13.7143V15.7143H67.8184H70.7275V18.5714V20.5714H72.7275H75.6366V26.2857H72.7275H70.7275V28.2857V31.1429H67.8184H65.8184V33.1429V36H62.9093H60.9093V38V40.8571H58.0002H56.0002V42.8571V45.7143H50.1821V42.8571V40.8571H48.1821H45.273V38V36H43.273H40.3639V33.1429V31.1429H38.3639H35.4548V28.2857V26.2857H33.4548H23.6366H21.6366V28.2857V31.1429H18.7275H16.7275V33.1429V36H13.8184H11.8184V38V40.8571H8.90934H6.90934V42.8571V45.7143H4.00024H2.00024V47.7143V62.2857V64.2857H4.00024H18.7275H20.7275V62.2857V59.4286H23.6366H25.6366V57.4286V54.5714H31.4548V57.4286V59.4286H33.4548H36.3639V62.2857V64.2857H38.3639H41.273V67.1429V69.1429H43.273H46.1821V72V74H48.1821H58.0002H60.0002V72V69.1429H62.9093H64.9093V67.1429V64.2857H67.8184H69.8184V62.2857V59.4286H72.7275H74.7275V57.4286V54.5714H77.6366H79.6366V52.5714V49.7143H82.5457H84.5457V47.7143V44.8571H87.4548H89.4548V42.8571V40H95.273V42.8571V44.8571H97.273H100.182V47.7143V49.7143H102.182H105.091V52.5714V54.5714H107.091H112H114V52.5714V4Z",
    stroke: "#003802",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_178_181",
    x: 0.000244141,
    y: 0,
    width: 116,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.448665 0 0 0 0 1 0 0 0 0 0.569959 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_178_181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.e9b96355f20f3e45e28cb620c03847ac.svg";
export { ForwardRef as ReactComponent };